module.exports = __webpack_public_path__ + "img/newlogo.962d525c.png";